// note: force-intersection-observer-polyfill-firefox.js must be imported before the IntersectionObserver polyfill
import './firefox-delete-native-intersection-observer'; // eslint-disable-line local-rules/ordered-imports
import 'intersection-observer'; // import IntersectionObserver polyfill (notably used by ViewportSeenWatcher class in Dashboards Standard mode)

import 'resize-observer-polyfill';

// create an alias to the global MessageChannel, so that it won't mess up with testcases
window.MessageChannelForTiming = window.MessageChannel;

// _monitorIntersections is a method that only exists in the IntersectionObserver polyfill, this is a fix for the polyfill itself
if (IntersectionObserver.prototype._monitorIntersections) {
  const oldFunc = IntersectionObserver.prototype._monitorIntersections;
  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    oldFunc.call(this, doc);

    // for some reason, the polyfill doesn't monitor non-null roots so we have to do it manually
    const root = this.root;
    if (root && !this.POLL_INTERVAL) {
      const callback = this._checkForIntersections;
      root?.addEventListener(`resize`, callback, true);
      root?.addEventListener(`scroll`, callback, true);
      this._monitoringUnsubscribes.push(function () {
        root?.removeEventListener(`resize`, callback, true);
        root?.removeEventListener(`scroll`, callback, true);
      });
    }
  };
}
